const MegaMenu = () => {

    let dataSource = $('.nav-lower__menu-wrapper .menu');
    let items = dataSource.find('.menu-item-has-children');

    $(items).on('mouseover', (e) => {
        let item = $(e.target);

        if ($(window).innerWidth() > 1279) {
            updateTabList(item);
        }
    })

    $(document).on('click', 'li.menu-item', e => {
        e.stopPropagation();
        let location = $(e.target).children('a').attr('href');

        if (typeof location != 'undefined' && $(window).innerWidth() > 1280) {
            window.location = $(e.target).children('a').attr('href');
        } else if ($(window).innerWidth() < 1280 && !$(e.currentTarget).hasClass('menu-item-has-children') && !$(e.currentTarget).hasClass('menu-item-back')) {
            window.location = $(e.target).children('a').attr('href');
        }
    })

    $(document).on('mouseover', '.mega-menu__left .menu-item-has-children', (e) => {

        if ($(window).innerWidth() > 1279) {
            let data = $(e.target).children('.sub-menu-wrap').html();

            if (typeof data === 'undefined') {
                data = $(e.target).siblings('.sub-menu-wrap').html();
            }

            if (typeof data === 'undefined') {
                return false;
            }

            $(e.target).addClass('active');
            $(e.target).siblings().removeClass('active');

            updateTabs(data);
        }
    })

    $('.mega-menu').on('mouseleave', () => {
        if ($(window).innerWidth() > 1279) {
            closeMenu();
        }
    })

    $('.nav__search-input').click(() => {
        if ($(window).innerWidth() > 1279) {
            closeMenu();
        }
    })
}

const updateTabList = (src) => {
    let source = $(src);

    $('.mega-menu__list').html(source.find('.sub-menu').html());
    $('.mega-menu__right').html("");

    openMenu();
}

const updateTabs = (data) => {
    $('.mega-menu__right').html(data);
}

const openMenu = () => {
    $('.mega-menu').addClass('active');
    $('body').addClass('menu-overlay');
}

const closeMenu = () => {
    $('.mega-menu').removeClass('active');
    $('body').removeClass('menu-overlay');
}

export default MegaMenu;


// WEBPACK FOOTER //
// ./src/js/app/components/MegaMenu.js